import {createContext, useContext, useMemo} from "react";
import {useForumsCommentRepliesRequest, useForumsCommentRequest} from "../request/api";

const CommentContext = createContext();

/**
 * Approach inspired by {@link https://blog.logrocket.com/guide-state-management-next-js/}
 */
export function CommentProvider({ children, topicId = undefined, commentId = undefined, shouldFetch = false }) {
  const commentsRequest = useForumsCommentRepliesRequest({
    topicId: topicId,
    commentId: commentId,
  }, {
    shouldFetch,
  }, {
    withCredentials: true,
  });

  const value = useMemo(
    () => ({
      comments: commentsRequest.data,
      isLoadingComments: commentsRequest.isLoading,
      reloadComments: commentsRequest.mutate,
      commentsError: commentsRequest.error,
      shouldFetchComments: shouldFetch,
    }),
    [commentsRequest, shouldFetch]
  );

  if (!commentId) {
    return (
      <>
        {children}
      </>
    );
  }

  return (
    <CommentContext.Provider value={value}>
      {children}
    </CommentContext.Provider>
  );
}

export function useCommentContext() {
  return useContext(CommentContext);
}
